{
  "name": "@ns/public-ledger-auto-payments-change-card",
  "version": "1.1.0",
  "description": "Change the company's automatic payments card (#25 phase 6). Held by the signatory who started it (from My Account); any public ledger signatory can claim it if it is released. The holder enters the new card (public-ledger/autopay/change-intent, then confirm-change-card, which holds it and completes the card changed). Completing it changed has its workflow schedule an account-signed public ledger record (a transfer of 1 tinybar from the company's public ledger account to its operating account): the signatories sign one public ledger record saying who changed the card, with no card details, and the held card becomes the automatic payments card once it has run on the public ledger. cancel ends the change and frees a held card.",
  "inputs": {},
  "outcomes": {
    "changed": {
      "serverOnly": true
    },
    "cancel": {}
  }
}
